import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem;

  & > h2 {
    font-weight: bold;
    margin: unset;
    color: ${({ theme }) => theme.colors.grayDark2};
  }

  &.detail-message {
    padding-top: 1rem;
  }

  & > .actions {
    display: flex;
    flex-direction: column;
    margin-top: 3rem;
    width: 23rem;

    & > button {
      margin-bottom: 0.875rem;
    }
  }
`;

export const TitleContainer = styled.div`
  padding-top: 1rem;
`;

export const CheckCircleIcon = styled.div`
  font-size: 0.063rem;
`;
